<div>
    <h1 mat-dialog-title>Paramètres de la simulation</h1>

    <form [formGroup]="planForm">
        <div class="page">
            <div class="main-body-container">
                <div class="general-and-option-container">
                    <div class="block-info flex-1">
                        <div class="title-and-button-container">
                            <h4 class="title-custom">Général</h4>
                        </div>
                        <div class="form-row-container">
                            <div class="tv-container-select-white-rect-extensible width-120px">
                                <mat-form-field>
                                    <mat-label>Campagne *</mat-label>
                                    <mat-select panelClass="tv-custom-always-visible-scroll-bar" formControlName="campaign">
                                        <mat-option
                                            class="tv-ns-select-option"
                                            *ngFor="let campaign of filteredCampaigns | async"
                                            [value]="campaign">
                                            {{ campaign.cpYear }} - {{ campaign.cpNum }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="tv-rect-input-extensible width-120px">
                                <mat-form-field>
                                    <mat-label>Taux de négo %</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        min="-100"
                                        max="0"
                                        step="5"
                                        formControlName="discount"
                                        (change)="onInvalidateGrossBudget()" />
                                </mat-form-field>
                            </div>

                            <div class="tv-square-input-for-date-pickers-no-label width-250px">
                                <mat-form-field class="tv-date-range-picker">
                                    <mat-label>Période</mat-label>
                                    <mat-datepicker-toggle matPrefix [for]="mainPeriodPicker"></mat-datepicker-toggle>
                                    <mat-date-range-input [formGroup]="planForm" [rangePicker]="mainPeriodPicker">
                                        <input matStartDate formControlName="startDate" />
                                        <input matEndDate formControlName="endDate" />
                                    </mat-date-range-input>
                                    <mat-date-range-picker #mainPeriodPicker></mat-date-range-picker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="form-row-container">
                            <span *ngIf="this.IsMainPeriodAWave" class="remark">
                                ❗ Les spots en dehors de la vague ne seront pas impactés
                            </span>
                        </div>
                    </div>

                    <div class="block-info flex-1">
                        <div class="title-and-button-container">
                            <h4 class="title-custom">Options</h4>
                        </div>
                        <div class="form-row-container">
                            <div class="tv-container-select-white-rect-extensible">
                                <mat-form-field>
                                    <mat-label for="allocationMode">Mode d'allocation *</mat-label>
                                    <mat-select
                                        panelClass="tv-custom-always-visible-scroll-bar"
                                        id="allocationMode"
                                        formControlName="allocationMode">
                                        <mat-option class="tv-ns-select-option" value="0">Remplacement</mat-option>
                                        <mat-option class="tv-ns-select-option" value="1">Superposition</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="tv-container-select-white-rect-extensible">
                                <mat-form-field>
                                    <mat-label for="optimizationMode">Optimiser *</mat-label>
                                    <mat-select
                                        panelClass="tv-custom-always-visible-scroll-bar"
                                        id="optimizationMode"
                                        formControlName="optimizationMode">
                                        <mat-option class="tv-ns-select-option" value="cgrp">Le coût GRP</mat-option>
                                        <mat-option class="tv-ns-select-option" value="reach">La couverture</mat-option>
                                        <mat-option class="tv-ns-select-option" value="repetition">La répétition</mat-option>
                                        <mat-option class="tv-ns-select-option" value="">Pas d'optimisation</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-info">
                    <div class="title-and-button-container">
                        <h4 class="title-custom">Vagues</h4>
                        <button class="tv-round-icon-button-icon-medium-light-blue" (click)="onAddWave()">
                            <mat-icon class="material-icons-outlined size-icon">add</mat-icon>
                        </button>
                    </div>
                    <div class="waves-container">
                        <ng-container *ngFor="let wave of this.rawWaves; index as index">
                            <div class="single-wave-container">
                                <div class="tv-square-input-for-date-pickers-no-label">
                                    <mat-form-field class="tv-date-range-picker">
                                        <mat-label>Période</mat-label>
                                        <mat-datepicker-toggle matPrefix [for]="wavePicker"></mat-datepicker-toggle>
                                        <mat-date-range-input [formGroup]="planForm" [rangePicker]="wavePicker">
                                            <input matStartDate [formControlName]="'waveStartDate' + index" />
                                            <input matEndDate [formControlName]="'waveEndDate' + index" />
                                        </mat-date-range-input>
                                        <mat-date-range-picker #wavePicker></mat-date-range-picker>
                                    </mat-form-field>
                                </div>
                                <button class="tv-round-icon-button-icon-medium-light-blue" (click)="onRemoveWave(index)">
                                    <mat-icon class="material-icons-outlined size-icon">delete</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                    <div class="form-row-container row-justify-left">
                        <span *ngIf="this.rawWaves.length > 0" class="remark">
                            ❗ Les spots en dehors {{ this.rawWaves.length > 1 ? 'des vagues' : 'de la vague' }} ne seront pas impactés
                        </span>
                    </div>
                </div>

                <div class="several-block-info-container">
                    <div class="block-info flex-1">
                        <div class="title-and-button-container">
                            <h4 class="title-custom">Formats</h4>
                            <button
                                *ngIf="this.selectedFormats.length < 6"
                                class="tv-round-icon-button-icon-medium-light-blue"
                                (click)="onAddFormat()">
                                <mat-icon class="material-icons-outlined size-icon">add</mat-icon>
                            </button>
                        </div>

                        <div *ngFor="let format of this.selectedFormats; index as index" class="formats-container">
                            <div class="tv-rect-input-extensible width-120px">
                                <mat-form-field>
                                    <mat-label>Durée</mat-label>
                                    <input matInput type="number" min="1" max="100" step="1" formControlName="{{ 'format' + index }}" />
                                </mat-form-field>
                            </div>
                            <div class="tv-rect-input-extensible width-120px">
                                <mat-form-field>
                                    <mat-label>Poids %</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        min="0"
                                        max="100"
                                        step="5"
                                        formControlName="{{ 'formatWeight' + index }}" />
                                </mat-form-field>
                            </div>
                            <button
                                *ngIf="this.selectedFormats.length > 1"
                                class="tv-round-icon-button-icon-medium-light-blue"
                                (click)="onRemoveFormat(index)">
                                <mat-icon class="material-icons-outlined size-icon">delete</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div class="block-info flex-1">
                        <div class="title-and-button-container">
                            <h4 class="title-custom">Tranches horaires</h4>
                        </div>
                        <div class="tv-rect-input-extensible" *ngFor="let daypart of this.allDayParts; index as index">
                            <mat-form-field>
                                <mat-label>{{ daypart.lib }} %</mat-label>
                                <input matInput type="number" min="0" max="100" step="5" formControlName="{{ 'dayPart' + daypart.code }}" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="block-info flex-1">
                        <div class="title-and-button-container">
                            <h4 class="title-custom">Budget net par chaine</h4>
                        </div>
                        <div class="tv-rect-input-extensible" *ngFor="let id of ['2', '3', '5']">
                            <mat-form-field class="tv-new-screen-information-input-skin-m">
                                <mat-label><img width="15px" [src]="getLogoChannelPath(id)" /></mat-label>
                                <input
                                    class="price-values"
                                    matInput
                                    type="text"
                                    thousandsSeparators
                                    [formControlName]="'channelBudget' + id"
                                    (change)="onInvalidateTotalBudget()" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="block-info">
                        <div class="title-and-button-container">
                            <h4 class="title-custom">Budget total</h4>
                        </div>
                        <div class="tv-rect-input-extensible">
                            <mat-form-field>
                                <mat-label>Brut</mat-label>
                                <input
                                    class="price-values"
                                    matInput
                                    type="text"
                                    thousandsSeparators
                                    formControlName="grossBudget"
                                    (change)="onInvalidateNetBudget(); onInvalidateChannelBudgets()" />
                            </mat-form-field>
                        </div>
                        <div class="tv-rect-input-extensible">
                            <mat-form-field>
                                <mat-label>Net</mat-label>
                                <input
                                    class="price-values"
                                    matInput
                                    type="text"
                                    thousandsSeparators
                                    formControlName="netBudget"
                                    (change)="onInvalidateGrossBudget(); onInvalidateChannelBudgets()" />
                            </mat-form-field>
                        </div>
                        <span *ngIf="!this.selectedReset" class="remark">❗ Seuls les spots déjà<br />enregistrés seront conservés </span>
                    </div>
                </div>

                <div class="block-info">
                    <div class="title-and-button-container">
                        <h4 class="title-custom">Evénements de l'écran</h4>
                        <div class="tv-custom-chip-list-item" (click)="onToggleTypeLogic()" *ngIf="this.selectedTypes.length > 0">
                            <div class="clickable">
                                {{ typeLogic }}
                            </div>
                        </div>
                    </div>
                    <div class="form-column-container-align-left">
                        <div class="form-row-container">
                            <mat-chip-set class="tv-chip-dark-square">
                                <mat-chip *ngFor="let type of this.selectedTypes">
                                    <div>
                                        {{ type.libevt }}
                                    </div>
                                    <button (click)="onRemoveType(type)" matChipRemove>
                                        <mat-icon class="icon-cancel">cancel</mat-icon>
                                    </button>
                                </mat-chip>
                            </mat-chip-set>
                        </div>
                        <div class="form-row-container row-justify-left">
                            <button *ngIf="this.screenTypes.length > 0" class="tv-ns-small-blue-button lib" (click)="onOpenTypeDialog()">
                                ajouter
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <mat-dialog-actions class="buttons-container">
                <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancel()">Annuler</button>
                <button *ngIf="isValid" class="tv-ns-validation-large-button" (click)="onValidate()">Valider</button>
                <button
                    *ngIf="isValid && !this.selectedReset && this.hasUnsavedSpots"
                    class="tv-ns-validation-large-button"
                    (click)="onValidate(true)">
                    Enregistrer et Valider
                </button>
            </mat-dialog-actions>
        </div>
    </form>
</div>
